import { Component, Input, ViewChild, SimpleChanges, OnInit, OnChanges, Output, EventEmitter } from '@angular/core';
import { MatTabGroup, MatTabHeader } from '@angular/material/tabs';

import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-phrases',
  templateUrl: './phrases.component.html',
  styleUrls: [ './phrases.component.css' ]
})
export class PhrasesComponent implements OnInit, OnChanges {
  @Input() note: any;
  @Input() selectedSource: any = null;
  @Input() forNoteType: any = null;
  @Input() useDragonStyle: any = false;
  @Input() updateTabGroup: any = null;
  @ViewChild( MatTabGroup, { static: false }) tabGroup: MatTabGroup;
  @Output() insertPhraseText: EventEmitter<any> = new EventEmitter();
  currentUser: any;

  constructor( private authService: AuthService ) {
    this.currentUser = this.authService.currentUser;
  }

  ngOnInit(): void {}

  ngOnChanges( changes: SimpleChanges ) {
    if (
      changes.updateTabGroup?.firstChange === false &&
      changes.updateTabGroup?.previousValue === false &&
      changes.updateTabGroup?.currentValue === true
    ) {
      ( this.tabGroup?._tabHeader as MatTabHeader ).updatePagination();
    }
  }
}
